<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="300" persistent>
        <v-card>
          <v-card-title class="text-h5 red darken-3 white--text">
            Subir archivo csv
          </v-card-title>
  
          <v-card-text> 
            <div class="row mt-2">
                <div class="col-12">
                    <v-select label="Seleccione mes:" v-model="input.mes" :items="meses" :item-value="'id'" outlined hide-details dense />
                </div>
                <div class="col-12">
                    <v-select label="Seleccione gestion:" v-model="input.gestion" :items="gestiones" outlined hide-details dense />
                </div>
                <div class="col-12">
                    <v-file-input
                        v-model="xarchivo"
                        accept=".csv"
                        dense
                        outlined
                        label="Archivo csv"
                        placeholder="Seleccione el archivo..."
                   />
                </div>
            </div> 
            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>            
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" :disabled="loading" outlined @click="enviar()"> Enviar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
<script>
import xaxios from '@/xaxios';

  export default {
      data() {
        return {
          loading: true,
          dialog: false,
          meses:[],
          gestiones:[],
          xarchivo: null,
          input :{mes:null, gestion:null, nit:{}}, 
        };
      }, 
      methods: {
        async openmodal(xproy,meses,gestiones) {
          this.input = xproy;
          this.meses = meses;
          this.gestiones = gestiones;
          this.xarchivo = null;
          this.loading = false;
          this.dialog = true; 
        },
        cerrar() { 
            this.dialog = false;
        },
        async enviar(){
            this.loading = true;

            const formData = new FormData();
            formData.append("file", this.xarchivo);
            formData.append("mes", this.input.mes);
            formData.append("anio", this.input.gestion);

            // apaptertest.esam.edu.bo/facturacion/facturas/upload
            let url = process.env.VUE_APP_FACT_REST+`/facturacion/facturas/upload`;
            let config = {
                method: 'POST',
                url: url,
                data: formData,
                headers: { 'Content-Type': 'application/json',apikey: this.input.nit.apikey },
            };
            let res = await xaxios.request(config).then(data => data).catch(error => error);
            window.console.log('res----->', res);
            if(res && res.data){
              this.$root.$notify.show(res.data, {color:'green',x: 'right',});
              this.$emit('cargado')
              this.dialog = false; 
            }

            this.loading = false;
        }
      },
    };
  </script>
  